import {
  Card,
  CardBody,
  Stat,
  StatGroup,
  StatLabel,
  StatNumber,
  StyleProps,
} from "@chakra-ui/react";
import { useFundFamilySummaryNavChartRetrieveSuspense } from "gen/endpoints/financial-reporting/financial-reporting";
import { ChartStat } from "gen/model/chartStat";
import { useTranslation } from "react-i18next";
import {
  CardSection,
  CardSectionBody,
  CardSectionGroup,
  CardSectionTitle,
} from "shared/components/card/CardSection";
import { MaybernChartWrapper } from "shared/components/chart/MaybernChartWrapper";
import {
  chartStatFormatters,
  moneyLabelFormatter,
} from "shared/components/chart/utils";
import colors from "theme/colors";

export const FundFamilySummaryChartNAV: React.FC<
  StyleProps & {
    fundFamilyId: string;
  }
> = ({ fundFamilyId, ...props }) => {
  const { t } = useTranslation(["fundFamily"]);
  const { data: chartData } =
    useFundFamilySummaryNavChartRetrieveSuspense(fundFamilyId);

  if (!chartData.data.length) {
    return null;
  }

  return (
    <Card variant="chart" {...props}>
      <CardBody>
        <CardSectionGroup>
          <CardSection flex={1} minWidth={0}>
            <CardSectionTitle>
              {t("fundFamily:summary.charts.nav.title")}
            </CardSectionTitle>
            <CardSectionBody height="300px">
              <MaybernChartWrapper
                {...chartData}
                xAxis={{
                  label: "%Y",
                }}
                yAxis={{
                  labelFormatter: moneyLabelFormatter,
                }}
                palette={{
                  strokes: [colors.cyan[800]],
                  fills: [colors.cyan[800]],
                }}
              />
            </CardSectionBody>
          </CardSection>
          <CardSection minWidth="220px">
            <CardSectionBody>
              <StatGroup>
                {chartData.stats?.map((item: ChartStat) => (
                  <Stat size="xs" w="100%" key={item.label}>
                    <StatNumber>
                      {chartStatFormatters[item.stat!.type](
                        item.stat! as never,
                      )}
                    </StatNumber>
                    <StatLabel>{item.label}</StatLabel>
                  </Stat>
                ))}
              </StatGroup>
            </CardSectionBody>
          </CardSection>
        </CardSectionGroup>
      </CardBody>
    </Card>
  );
};
